module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', [(!_vm.editors.length) ? _c('div', [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(('First time: ' + _vm.label || 'Permissions')))]), _vm._v("\n\n        No write permissions\n        "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.initialisePermissions
    }
  }, [_vm._v("Create")])], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite) ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label || 'Permissions'))]), _vm._v(" "), _vm._l((_vm.editors), function(uid) {
    return _c('div', {
      key: uid
    }, [_vm._v("\n            " + _vm._s(uid) + "\n        ")])
  })] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e6c5b58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/Permissions.vue
// module id = 2595
// module chunks = 1